export const apiUrl: string | undefined = "https://gbt-api.com/api/v1";
